// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  position: relative;
  text-transform: uppercase;
`

const Wrapper = styled.div`
  padding: 8px 16px 16px;
  width: 340px;

  > div:first-child {
    font-size: 12px;
    margin-bottom: 16px;
  }
`

const FormsContainer = styled.div`
  margin-bottom: 20px;
`

const FormWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const SwitchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 1px solid lightgray;
`

export { Header, Wrapper, FormsContainer, FormWrapper, SwitchWrapper }
